
import './src/scss/furniture-mattress-protection-plans.scss';
import pkg from './package.json';

/* eslint-disable-next-line no-unused-vars,no-global-assign,no-undef,camelcase */
__webpack_public_path__ = `${pkg.version}/`;

export default {
  start: () => {
    // REPLACE THE CONTENTS OF THIS FUNCTION WITH YOUR CUSTOM CODE

    // create a new div element
    const newDiv = document.createElement('div');
    newDiv.setAttribute('class', 'insertedDiv');
    // and give it some content
    const newContent = document.createTextNode('Hi there and greetings!');
    // add the text node to the newly created div
    newDiv.appendChild(newContent);

    // add the newly created element and its content into the DOM
    const currentDiv = document.getElementsByClassName('example-partial');
    if (currentDiv.length) {
      document.body.insertBefore(newDiv, currentDiv[0]);
    }
  },
};




// WEBPACK FOOTER //
// /opt/jenkins_home/workspace/marketing-campaigns_deploy_trigger_ce/package/app.js